import { API_ROOT } from 'environment';

angular.module('app.resources').factory('ChannelTicket', ($q, $resource) =>
    $resource(`${API_ROOT}/channels/:channel_id/tickets/:id`, { id: '@id', channel_id: '@channel_id' }, {
        refund: {
            method: 'POST',
            url: `${API_ROOT}/channels/:channel_id/tickets/:id/refund`
        }
    })
);


// WEBPACK FOOTER //
// ./resources/channel_ticket.js